export default {
  resourcePool: {
    projectAssetLibrary: 'プロジェクトアセット',
    publicAssetLibrary: '共有アセット',
    projectAsset: {
      addFilter: {
        title: '状態',
        added: '追加済み',
        notAdded: '未追加',
      },
      bg: '背景画像',
      bgm: 'BGM',
      bgTip: 'グローバル設定でBGMを編集してください',
      bgmTip: 'グローバル設定でBGMを編集してください',
      replace: 'アセットの置き換え',
      loaclUpload: 'ローカルアップロード',
      fromLib: 'ライブラリから追加',
      chooseAsset: 'アセットライブラリから選択',
      edit: 'クリッピング',
      clip: '編集',
      download: 'ダウンロード',
      delete: '削除',
      deleteTitle: '追加されたアセットを削除',
      deleteContent:
        'プロジェクトに追加されたアセットが削除されると、対応するレイヤーも一緒に削除されます。',
    },
    resource: {
      uploadForbidden: {
        type: '現在のテンプレートはこのファイル形式をサポートしていません',
        play: 'チェスボードのクイックレイアウトはこのファイル形式をサポートしていません',
      },
    },
    assetLibrary: 'アセットライブラリ',
    myAssetLibrary: 'マイライブラリ',
    assetTab: {
      all: 'すべて',
      image: '画像',
      video: '動画',
      audio: '音声',
      bgm: 'BGM',
      sound: '効果音',
      aImage: 'GIF',
      particle: 'パーティクル',
    },
  },
  uoload: {
    tips: 'クリックしてファイルをアップロードするか、ファイルをこの領域にドラッグアンドドロップします',
    subTips: {
      video: '動画ファイル：mp4、<{size}M',
      image: '画像ファイル：jpg/jpeg/png、<{size}M',
      audio: '音声ファイル：mp3、<{size}M',
      seq: 'シーケンスフレームファイル：zip(png)、<{size}M',
      dragonBone: 'DragonBonesファイル：zip(json+png)、<{size}M',
      seqSizeTip: '画像サイズが一致しません',
      seqMaxSizeTip:
        'シーケンスフレームのサイズは {size}MB を超えてはいけません',
      seqFormatTip: 'シーケンスフレームファイルの形式が正しくありません',
    },
  },
  upload: {
    task: {
      tips: '{num} / {total} ファイルがアップロードされました',
    },
    unsupportedFileTip: 'サポートされていないファイル形式',
    subTips: {
      unknownError: '不明なエラーメッセージ',
    },
    acceptTip:
      '{resource} は “{accept}” フォーマットのみサポートされています。以下のファイルはアップロードできません：',
  },
  resource: {
    addToPlayable: {
      error: {
        seq: '現在のアセットはシーケンスフレームではありません',
        particle: '現在のアセットはパーティクルではありません',
        dragonBone: '現在のアセットはDragonBonesではありません',
        dragonBoneUnsupported:
          '現在のテンプレートではDragonBonesを追加できません',
        dragonBoneFormat:
          'DragonBonesファイルは2つのjsonと1つのpngファイルである必要があります',
      },
    },
    category: {
      contact:
        'この機能は正式なアカウントのみ使用可能であり、営業と連絡してください。',
    },
    quickLayout: {
      error: '既にショートカットレイアウトが含まれており、追加できません',
    },
    apply: {
      public: '外部',
      internal: '内部',
    },
  },
  project: {
    editingTip: 'プロジェクトは編集中です。しばらくしてから再試行してください',
    notexistTip: 'アカウントにこのプロジェクトはありません',
  },
  eventSetting: {
    warnText:
      'タイミングトリガーのパラメーターを変更は推奨しません。プレイアブル広告が正常に動作しなくなる可能性があります。',
    delayText:
      '遅延時間が1秒を超えるアプリストアへのジャンプイベントはブロックされる可能性があります。遅延時間を1秒以内に減少させることをお勧めします。',
    triggerDelayText:
      'アプリストアへのジャンプイベントがトリガーされ、ユーザーとの最後の相互作用からの時間が1秒以上ある場合、ブロックされる可能性があります。この時間間隔が長すぎないように確認してください。',
  },
  quickToolBar: {
    eventManager: {
      title: 'カスタムトラッキング',
      sourceTips: '現在のシーン以外のトラッキングポイントが特定できません。',
    },
    title: 'クイックポジショニング',
  },
  textStyle: {
    update: {
      error: 'フォントの変更に失敗しました',
    },
  },
  remindDialog: {
    content:
      'パッケージサイズは、各ネットワークの要件内にできるだけ収めてください。多少超過した場合は、ダウンロード時に圧縮することで対応可能です。詳細は',
    toHelp: 'ヘルプセンター。',
    table: {
      sizeLimit: 'パッケージサイズ',
      other: 'その他',
    },
    ok: '確認',
  },
}
